import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { CronGeneratorContext, ICronGeneratorContext } from '../../../../cronGeneratorState/cronGeneratorContext';
import style from './CronGeneratorResult.module.scss';

const CronGeneratorResult: React.FC = () => {
	const { seconds, minutes, hours, dayOfMonth, month, dayOfWeek, year } =
		useContext<ICronGeneratorContext>(CronGeneratorContext);

	return (
		<div className={style.container} data-test="CronGeneratorResult">
			<Text
				className={style.heading}
				translationNameSpace="form"
				translationKey="cronExpressionLabel"
				theme="secondary"
				size="l"
				weight="bold"
				align="center"
			/>
			<div className={style.expression}>
				<Text
					translationNameSpace="form"
					translationKey="cronExpressionValue"
					size="xl"
					weight="bold"
					align="center"
					translationOptions={{
						// seconds,
						minutes,
						hours,
						dayOfMonth,
						month,
						dayOfWeek,
						// year,
					}}
				/>
			</div>
			<div className={style.expressionTable}>
				{/*<div className={style.column}>*/}
				{/*	<Text*/}
				{/*		className={style.columnHeading}*/}
				{/*		translationNameSpace="form"*/}
				{/*		translationKey="secondsLabel"*/}
				{/*		weight="bold"*/}
				{/*	/>*/}
				{/*	<Text className={style.columnValue} translationKey={seconds} />*/}
				{/*</div>*/}
				<div className={style.column}>
					<Text
						className={style.columnHeading}
						translationNameSpace="form"
						translationKey="minutesLabel"
						weight="bold"
						withTooltip={true}
					/>
					<Text className={style.columnValue} translationKey={minutes} withTooltip={true} />
				</div>
				<div className={style.column}>
					<Text
						className={style.columnHeading}
						translationNameSpace="form"
						translationKey="hoursLabel"
						weight="bold"
						withTooltip={true}
					/>
					<Text className={style.columnValue} translationKey={hours} withTooltip={true} />
				</div>
				<div className={style.column}>
					<Text
						className={style.columnHeading}
						translationNameSpace="form"
						translationKey="dayOfMonthLabel"
						weight="bold"
						withTooltip={true}
					/>
					<Text className={style.columnValue} translationKey={dayOfMonth} withTooltip={true} />
				</div>
				<div className={style.column}>
					<Text
						className={style.columnHeading}
						translationNameSpace="form"
						translationKey="monthLabel"
						weight="bold"
						withTooltip={true}
					/>
					<Text className={style.columnValue} translationKey={month} withTooltip={true} />
				</div>
				<div className={style.column}>
					<Text
						className={style.columnHeading}
						translationNameSpace="form"
						translationKey="dayOfWeekLabel"
						weight="bold"
						withTooltip={true}
					/>
					<Text className={style.columnValue} translationKey={dayOfWeek} withTooltip={true} />
				</div>
				{/*<div className={style.column}>*/}
				{/*	<Text*/}
				{/*		className={style.columnHeading}*/}
				{/*		translationNameSpace="form"*/}
				{/*		translationKey="yearLabel"*/}
				{/*		weight="bold"*/}
				{/*	/>*/}
				{/*	<Text className={style.columnValue} translationKey={year} />*/}
				{/*</div>*/}
			</div>
		</div>
	);
};

export default CronGeneratorResult;
